/*
  小さな動きの共通部品 (2026-10-12)。HP の最初の画面で採った2つを、LP でも使えるようにした。
  どちらも CSS だけで、JS は足さない。字は最初の描画から見えていて (opacity で出さない)、
  動くのは transform と色だけなので、字の箱の大きさは変わらない (CLS 0)。動きは1回だけで、
  reduced motion では最初から動いたあとの形で止まる。

  取り消し線 (mm-strike と mm-key)
    「〜だけでは、〜ならない」のように、否定して言い直す見出しの否定の側を mm-strike で包む。
    言い直しの側は mm-key で包む。線が左から走り、その行が少し沈み、続けて言い直しが一段大きくなる。
    線は ::after の飾りなので読み上げには出ない。見出しの文は変えない。
    mm-key は transform を使うので、inline のままだと効かない。この CSS が inline-block にする。
    始まりは --mm-at (既定 0ms)、色は --mm-dim と --mm-line で替える。

  矢印が押す (mm-push)
    ボタンの矢印の要素に付ける。矢印だけを前へ一度押し出して戻すので、ボタンの字や大きさに依らない。
    矢印の要素が自分の持ち物でないとき (HP の部品の矢印、→ の文字) は、ボタンを含む親に mm-push-in を付けると、その中の .hx-arrow と .arr が動く。
    ボタンは動き中も押せる。始まりは --mm-push-at (既定 1300ms。取り消し線のあとに動く順番)、
    押し出す幅は --mm-push-x (既定 8px)。矢印が無いボタンには付けない。
    transform で動かす。矢印に Tailwind の -translate-y-1/2 (translate 属性) が付いていても重ならない。
*/
export const MICRO_MOTION_CSS = `
.mm-strike{position:relative;display:inline-block;color:var(--mm-dim,rgba(255,255,255,.62))}
.mm-strike::after{content:"";position:absolute;left:-.04em;right:.3em;top:54%;height:.09em;min-height:2px;border-radius:2px;background:var(--mm-line,#fff)}
.mm-key{display:inline-block;transform-origin:left bottom;transform:scale(1.08)}
@media (prefers-reduced-motion:no-preference){
  .mm-strike{animation:mmSink 300ms var(--m-out,cubic-bezier(.2,.7,.2,1)) calc(var(--mm-at,0ms) + 700ms) both}
  .mm-strike::after{transform-origin:left center;animation:mmStrike 500ms cubic-bezier(.55,.05,.25,1) calc(var(--mm-at,0ms) + 300ms) both}
  .mm-key{animation:mmRise 450ms cubic-bezier(.3,1.4,.5,1) calc(var(--mm-at,0ms) + 800ms) both}
  .mm-push,.mm-push-in :is(.hx-arrow,.arr){animation:mmPush 650ms cubic-bezier(.3,0,.2,1) var(--mm-push-at,1300ms)}
  @keyframes mmStrike{from{transform:scaleX(0)}to{transform:scaleX(1)}}
  @keyframes mmSink{from{color:var(--mm-line,#fff)}to{color:var(--mm-dim,rgba(255,255,255,.62))}}
  @keyframes mmRise{from{transform:none}to{transform:scale(1.08)}}
  @keyframes mmPush{0%{transform:none}45%{transform:translateX(var(--mm-push-x,8px))}100%{transform:none}}
}
`;
